import { useFormatter } from 'use-intl';

const useFormatPrice = (
  price: number | undefined,
  compact: boolean,
  minimumFractionDigits = 0
) => {
  const intl = useFormatter();

  if (price === null || price === undefined) return null;

  return intl.number(Math.round(price), {
    minimumFractionDigits,
    maximumFractionDigits: 1,
    useGrouping: true,
    notation: compact ? 'compact' : 'standard',
  });
};

export default useFormatPrice;
